import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import Layout from "../Layout";
import LoginPage from "../screens/login";
import NotFoundPage from "../screens/notFound";
import BannerPage from "../screens/banner/component";
import CreateBannerPage from "../screens/banner/component/createBannerComponent";

import CategoryPage from "../screens/category/component";
import CreateCategoryComponent from "../screens/category/component/tab/categoryTabsComponent";

import PostPage from "../screens/post/component";
import PostTabsComponent from "../screens/post/component/postTabsComponent";

import ProductPage from "../screens/product/component";

import CreateUserComponent from "../screens/user/component/createUserComponent";
import UserPage from "../screens/user/component";

import CreateRoleComponent from "../screens/role/component/createUserComponent";
import RolePage from "../screens/role/component";

import CreatePartnerComponent from "../screens/partner/component/createPartnerComponent";
import ParterPage from "../screens/partner/component";

import CreateCertificateComponent from "../screens/certificate/component/createCertificateComponent";
import CertificatePage from "../screens/certificate/component";

import LanguageComponent from "../screens/language/component/createLanguageComponent";
import LanguagePage from "../screens/language/component";

import CreateContactComponent from "../screens/contact/component/createContactComponent";
import ContactPage from "../screens/contact/component";

import InforContactTabsComponent from "../screens/inforContact/component/InforContactTabsComponent";
import InforContactPage from "../screens/inforContact/component";

import CreateRecruimentComponent from "../screens/recruiment/component/createRecruimentComponent";
import RecruimentPage from "../screens/recruiment/component";
import { IUserState } from "../screens/user/propState";
import { isCheckPermisson } from "../utils";
import { PERMISSION_ENUM } from "../utils/permisson.enum";
import DashBoardPage from "../screens/DashBoard";
import CustomerPage from "../screens/crm/customer/pages/listCustomer/component";
import blockInfo from "../screens/crm/customer/pages/detailCustomer/blockInfo";

const PrivateRoute = ({ ...routeProps }: any) => {
  const isAuth = useAppSelector((state: any) => state.auth.userInfo);
  const userState = useAppSelector<IUserState>((state) => state.screens.user);
  const permissionObj = userState.permissionObj;

  if (isAuth.access_token) {
    const prop =
      isCheckPermisson(permissionObj, routeProps.permission)
        ? { ...routeProps }
        : {
          ...routeProps,
          component: NotFoundPage,
        };
    return (
      <Layout>
        <Route {...prop} />
      </Layout>
    );
  } else {
    return <Redirect to={{ pathname: "/login" }} />;
  }
};

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/login" component={LoginPage} />
        <PrivateRoute
          path="/dashboard"
          component={DashBoardPage}
        />
        <PrivateRoute
          path="/user/profile/:id"
          component={CreateUserComponent}
        />
        <PrivateRoute
          module="post"
          permission={PERMISSION_ENUM.POST_CREATE}
          path="/post/create"
          component={PostTabsComponent}
        />
        <PrivateRoute
          module="post"
          permission={PERMISSION_ENUM.POST_UPDATE}
          path="/post/update/:id"
          component={PostTabsComponent}
        />
        <PrivateRoute
          module="post"
          permission={[PERMISSION_ENUM.POST_LIST, PERMISSION_ENUM.POST_CREATE]}
          path="/post"
          component={PostPage}
        />

        <PrivateRoute
          module="product"
          permission={PERMISSION_ENUM.POST_CREATE}
          path="/product/create"
          component={PostTabsComponent}
        />
        <PrivateRoute
          module="product"
          permission={PERMISSION_ENUM.POST_UPDATE}
          path="/product/update/:id"
          component={PostTabsComponent}
        />
        <PrivateRoute
          module="product"
          permission={[PERMISSION_ENUM.POST_LIST, PERMISSION_ENUM.POST_CREATE]}
          path="/product"
          component={ProductPage}
        />

        <PrivateRoute
          module="contact"
          permission={PERMISSION_ENUM.CONTACT_CREATE}
          path="/contact/create"
          component={CreateContactComponent}
        />
        <PrivateRoute
          module="contact"
          permission={PERMISSION_ENUM.CONTACT_UPDATE}
          path="/contact/update/:id"
          component={CreateContactComponent}
        />
        <PrivateRoute
          module="contact"
          permission={[PERMISSION_ENUM.CONTACT_LIST, PERMISSION_ENUM.CONTACT_CREATE]}
          path="/contact"
          component={ContactPage}
        />

        <PrivateRoute
          module="inforContact"
          permission={PERMISSION_ENUM.INFOR_CONTACT_CREATE}
          path="/infor/contact/create"
          component={InforContactTabsComponent}
        />
        <PrivateRoute
          module="inforContact"
          permission={PERMISSION_ENUM.INFOR_CONTACT_UPDATE}
          path="/infor/contact/update/:id"
          component={InforContactTabsComponent}
        />
        <PrivateRoute
          module="inforContact"
          permission={[PERMISSION_ENUM.INFOR_CONTACT_LIST, PERMISSION_ENUM.INFOR_CONTACT_CREATE]}
          path="/infor/contact"
          component={InforContactPage}
        />

        <PrivateRoute
          module="user"
          permission={PERMISSION_ENUM.USER_CREATE}
          path="/user/create"
          component={CreateUserComponent}
        />
        <PrivateRoute
          module="user"
          permission={PERMISSION_ENUM.USER_UPDATE}
          path="/user/update/:id"
          component={CreateUserComponent}
        />
        <PrivateRoute
          module="user"
          permission={[PERMISSION_ENUM.USER_LIST, PERMISSION_ENUM.USER_CREATE]}
          path="/user"
          component={UserPage}
        />

        <PrivateRoute
          module="role"
          permission={PERMISSION_ENUM.ROLE_CREATE}
          path="/role/create"
          component={CreateRoleComponent}
        />
        <PrivateRoute
          module="role"
          permission={PERMISSION_ENUM.ROLE_UPDATE}
          path="/role/update/:id"
          component={CreateRoleComponent}
        />
        <PrivateRoute
          module="role"
          permission={[PERMISSION_ENUM.ROLE_LIST, PERMISSION_ENUM.ROLE_CREATE]}
          path="/role"
          component={RolePage}
        />

        <PrivateRoute
          module="crm"
          permission={PERMISSION_ENUM.ROLE_CREATE}
          path="/crm/customer"
          component={CustomerPage}
        />

        <PrivateRoute
          module="crm"
          permission={[PERMISSION_ENUM.ROLE_CREATE, PERMISSION_ENUM.ROLE_UPDATE, PERMISSION_ENUM.ROLE_LIST]}
          path="/crm/customer-detail/:id"
          component={blockInfo}
        />

        <PrivateRoute
          module="crm"
          permission={PERMISSION_ENUM.ROLE_CREATE}
          path="/crm/customer-care"
          // component={blockInfo}
        />

        <PrivateRoute
          module="crm"
          permission={PERMISSION_ENUM.ROLE_CREATE}
          path="/crm/marketing"
        // component={CreateRoleComponent}
        />

        <PrivateRoute
          module="crm"
          permission={PERMISSION_ENUM.ROLE_CREATE}
          path="/crm/task-management"
        // component={CreateRoleComponent}
        />

        <PrivateRoute
          module="banner"
          permission={PERMISSION_ENUM.BANNER_CREATE}
          path="/banner/create"
          component={CreateBannerPage}
        />
        <PrivateRoute
          module="banner"
          permission={PERMISSION_ENUM.BANNER_UPDATE}
          path="/banner/update/:id"
          component={CreateBannerPage}
        />
        <PrivateRoute
          module="banner"
          permission={[PERMISSION_ENUM.BANNER_LIST, PERMISSION_ENUM.BANNER_CREATE]}
          path="/banner"
          component={BannerPage}
        />

        <PrivateRoute
          module="certificate"
          permission={PERMISSION_ENUM.CERTIFICATE_CREATE}
          path="/certificate/create"
          component={CreateCertificateComponent}
        />
        <PrivateRoute
          module="certificate"
          permission={PERMISSION_ENUM.CERTIFICATE_UPDATE}
          path="/certificate/update/:id"
          component={CreateCertificateComponent}
        />
        <PrivateRoute
          module="certificate"
          permission={[PERMISSION_ENUM.CERTIFICATE_LIST, PERMISSION_ENUM.CERTIFICATE_CREATE]}
          path="/certificate"
          component={CertificatePage}
        />

        <PrivateRoute
          module="language"
          permission={PERMISSION_ENUM.LANGUAGE_CREATE}
          path="/language/create"
          component={LanguageComponent}
        />
        <PrivateRoute
          module="language"
          permission={PERMISSION_ENUM.LANGUAGE_UPDATE}
          path="/language/update/:id"
          component={LanguageComponent}
        />
        <PrivateRoute
          module="language"
          permission={[PERMISSION_ENUM.LANGUAGE_LIST, PERMISSION_ENUM.LANGUAGE_CREATE]}
          path="/language"
          component={LanguagePage}
        />

        <PrivateRoute
          module="recruiment"
          permission={PERMISSION_ENUM.RECRUIMENT_CREATE}
          path="/recruiment/create"
          component={CreateRecruimentComponent}
        />
        <PrivateRoute
          module="recruiment"
          permission={PERMISSION_ENUM.RECRUIMENT_UPDATE}
          path="/recruiment/update/:id"
          component={CreateRecruimentComponent}
        />
        <PrivateRoute
          module="recruiment"
          permission={[PERMISSION_ENUM.RECRUIMENT_LIST, PERMISSION_ENUM.RECRUIMENT_CREATE]}
          path="/recruiment"
          component={RecruimentPage}
        />

        <PrivateRoute
          module="category"
          permission={PERMISSION_ENUM.CATEGORY_CREATE}
          path="/category/create"
          component={CreateCategoryComponent}
        />
        <PrivateRoute
          module="category"
          permission={PERMISSION_ENUM.CATEGORY_UPDATE}
          path="/category/update/:id"
          component={CreateCategoryComponent}
        />
        <PrivateRoute
          module="category"
          permission={[PERMISSION_ENUM.CATEGORY_LIST, PERMISSION_ENUM.CATEGORY_CREATE]}
          path="/category"
          component={CategoryPage}
        />

        <PrivateRoute
          module="partner"
          permission={PERMISSION_ENUM.PARTNER_CREATE}
          path="/partner/create"
          component={CreatePartnerComponent}
        />
        <PrivateRoute
          module="partner"
          permission={PERMISSION_ENUM.PARTNER_UPDATE}
          path="/partner/update/:id"
          component={CreatePartnerComponent}
        />
        <PrivateRoute
          module="partner"
          permission={[PERMISSION_ENUM.PARTNER_LIST, PERMISSION_ENUM.PARTNER_CREATE]}
          path="/partner"
          component={ParterPage}
        />

        <PrivateRoute path="/" component={DashBoardPage} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </BrowserRouter>
  );
};
export default Router;
